import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { DISHES, ORDER_URL } from "./data";

function DishCard({ dish, large }) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      data-testid={`featured-dish-card-${dish.id}`}
      className={`card-glow group relative flex flex-col overflow-hidden rounded-2xl border border-[#C97B5F]/15 bg-white shadow-[0_16px_50px_rgba(0,0,0,0.5)] transition-colors duration-300 hover:border-[#E86A24]/40 ${
        large ? "lg:row-span-2" : ""
      }`}
    >
      <div className={`relative overflow-hidden ${large ? "aspect-[4/3] lg:aspect-auto lg:flex-1" : "aspect-[16/9]"}`}>
        <img
          src={dish.image}
          alt={dish.name}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#FDFCF9]/60 via-transparent to-transparent" />
        <span className="absolute left-4 top-4 rounded-full bg-[#FDFCF9]/80 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.18em] text-[#8A3324] backdrop-blur-sm border border-[#C97B5F]/30">
          {dish.badge}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-5">
        <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-[#E86A24]">{dish.category}</p>
        <div className="mt-1.5 flex items-start justify-between gap-3">
          <h3 className="font-display text-lg font-semibold text-[#3A2C1E] sm:text-xl">{dish.name}</h3>
          <span data-testid={`dish-price-${dish.id}`} className="shrink-0 font-display text-lg font-bold text-[#8A3324]">{dish.price}</span>
        </div>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-stone-500">{dish.description}</p>
        <a
          href={ORDER_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`featured-dish-order-button-${dish.id}`}
          className="mt-4 inline-flex w-fit items-center gap-1.5 rounded-full border border-[#E86A24]/50 px-4 py-2 text-[11px] font-bold uppercase tracking-widest text-[#E86A24] transition-colors duration-200 hover:bg-[#E86A24] hover:text-white"
        >
          Order This Dish <ArrowUpRight size={13} />
        </a>
      </div>
    </motion.article>
  );
}

export default function Dishes() {
  return (
    <section id="dishes" data-testid="featured-dishes-section" className="scroll-mt-20 bg-[#F9F3EA] py-20 sm:py-28">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="max-w-2xl">
          <p className="text-xs font-bold uppercase tracking-[0.3em] text-[#E86A24]">Chef's Selection</p>
          <h2 className="mt-3 font-display text-2xl font-semibold tracking-tight text-[#3A2C1E] sm:text-3xl lg:text-4xl">
            Featured & Popular Dishes
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-stone-500 sm:text-base">
            The plates our Chapel Hill regulars can't stop ordering — from smoky tandoori kebabs to our famous butter chicken.
          </p>
        </div>
        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-2">
          <DishCard dish={DISHES[0]} large />
          <DishCard dish={DISHES[1]} />
          <DishCard dish={DISHES[2]} />
          <div className="sm:col-span-2">
            <DishCard dish={DISHES[3]} />
          </div>
        </div>
      </div>
    </section>
  );
}
